import * as XLSX from 'xlsx';

export const exportToExcel = (data, filename) => {
  if (!data || !data.results || data.results.length === 0) {
    alert('No data available to export');
    return;
  }
  
  try {
    const headers = Object.keys(data.results[0]).filter(k => 
      !k.toLowerCase().endsWith('id') || ['invoiceNumber'].includes(k)
    );
    const readableHeaders = headers.map(h => h.replace(/([A-Z])/g, ' $1').trim());
    
    const cleanData = data.results.map(row => {
      const cleanRow = {};
      headers.forEach((header, index) => {
        const readableHeader = readableHeaders[index];
        let value = row[header];
        
        if (value === null || value === undefined) {
          value = '';
        } else if (typeof value === 'object') {
          value = JSON.stringify(value);
        } else {
          value = String(value);
        }
        
        cleanRow[readableHeader] = value;
      });
      return cleanRow;
    });
    
    const ws = XLSX.utils.json_to_sheet(cleanData);
    const colWidths = readableHeaders.map(header => ({
      wch: Math.max(header.length, 15)
    }));
    ws['!cols'] = colWidths;
    
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, `${filename}.xlsx`);
    
  } catch (error) {
    console.error('Excel export failed:', error);
    alert(`Excel export failed: ${error.message}. Please try again.`);
  }
};

export const exportToPDF = (data, query) => {
  if (!data || !data.results || data.results.length === 0) {
    alert('No data available to export');
    return;
  }
  
  try {
    const headers = Object.keys(data.results[0]).filter(k => 
      !k.toLowerCase().endsWith('id') || ['invoiceNumber'].includes(k)
    );
    const readableHeaders = headers.map(h => h.replace(/([A-Z])/g, ' $1').trim());
    
    const maxRecords = 500;
    const limitedResults = data.results.slice(0, maxRecords);
    const isLimited = data.results.length > maxRecords;
    
    const htmlContent = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>Report</title>
  <style>
    @page { margin: 0.7in; size: A4; }
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      margin: 0;
      padding: 0;
      font-size: 11px;
      line-height: 1.3;
    }
    .header {
      border-bottom: 2px solid #4F7CFF;
      margin-bottom: 15px;
      padding-bottom: 10px;
    }
    .header h1 {
      color: #4F7CFF;
      margin: 0 0 5px 0;
      font-size: 20px;
      font-weight: 700;
    }
    .metadata {
      background-color: #f8fafc;
      padding: 10px;
      border-radius: 6px;
      margin-bottom: 15px;
      border: 1px solid #e2e8f0;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 10px;
      font-size: 9px;
    }
    th {
      background-color: #1e293b;
      color: white;
      padding: 6px 4px;
      text-align: left;
      font-weight: 600;
      font-size: 8px;
      text-transform: uppercase;
      border: 1px solid #374151;
    }
    td {
      padding: 4px;
      border: 1px solid #e2e8f0;
      vertical-align: top;
      word-wrap: break-word;
    }
    tr:nth-child(even) { background-color: #f8fafc; }
    tr:nth-child(odd) { background-color: white; }
  </style>
</head>
<body>
  <div class="header">
    <h1>Report</h1>
    <div style="color: #64748b; font-size: 12px;">Pool Brain Manager</div>
  </div>

  <div class="metadata">
    <div><strong>Query:</strong> ${query}</div>
    <div><strong>Total Results:</strong> ${data.total_count || data.results.length} records</div>
    <div><strong>Generated:</strong> ${new Date().toLocaleString()}</div>
  </div>

  ${isLimited ? `<div style="background-color: #fef3c7; padding: 8px; margin-bottom: 10px;">
    <strong>Note:</strong> Showing first ${maxRecords} records only.
  </div>` : ''}

  <table>
    <thead>
      <tr>${readableHeaders.map(h => `<th>${h}</th>`).join('')}</tr>
    </thead>
    <tbody>
      ${limitedResults.map(row => `<tr>
        ${headers.map(h => `<td>${String(row[h] || '-').substring(0, 30)}</td>`).join('')}
      </tr>`).join('')}
    </tbody>
  </table>

  <script>
    window.addEventListener('load', function() {
      setTimeout(function() {
        window.print();
        setTimeout(() => window.close(), 1000);
      }, 500);
    });
  </script>
</body>
</html>`;

    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const printWindow = window.open(url, '_blank', 'width=900,height=700');
    
    if (printWindow) {
      printWindow.addEventListener('beforeunload', () => URL.revokeObjectURL(url));
    } else {
      URL.revokeObjectURL(url);
      alert('Please allow popups for PDF export.');
    }
  } catch (error) {
    console.error('PDF export error:', error);
    alert('PDF export failed. Use Excel export for large datasets.');
  }
};